/* eslint-disable react-refresh/only-export-components */
import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "../../lib/utils"

const badgeVariants = cva(
  "inline-flex items-center justify-center gap-1 px-2 py-0.5 text-xs font-semibold transition-colors focus:ring-2 focus:ring-neutrals-500 focus:ring-offset-2 focus:outline-hidden",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary-blue-600 text-neutrals-100 shadow-xs hover:bg-primary-blue-600/80",
        secondary:
          "border-transparent bg-neutrals-300 text-neutrals-800 hover:bg-neutrals-500/40",
        "secondary-light":
          "border-transparent bg-neutrals-200 font-normal text-neutrals-900 hover:bg-neutrals-500/40",
        destructive:
          "border-transparent bg-primary-red-400 text-neutrals-100 shadow-xs hover:bg-primary-red-200",
        "secondary-indigo":
          "border-transparent bg-secondary-indigo-500 text-neutrals-100",
        outline: "border border-solid border-neutrals-300 text-neutrals-700",
        blue: "border-transparent bg-primary-blue-100 text-primary-blue-600",
      },
      type: {
        pill: "rounded-full",
        rectangle: "rounded-md",
      },
    },
    defaultVariants: {
      variant: "default",
      type: "rectangle",
    },
  }
)
/* 
export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, type, ...props }: BadgeProps) {
  return (
    <div
      className={cn(badgeVariants({ variant, type }), className)}
      {...props}
    />
  );
} */

function Badge({
  className,
  variant,
  type,
  asChild = false,
  ...props
}: React.ComponentProps<"span"> &
  VariantProps<typeof badgeVariants> & { asChild?: boolean }) {
  const Comp = asChild ? Slot : "span"
  return (
    <Comp
      data-slot="badge"
      data-variant={variant}
      className={cn(badgeVariants({ variant, type }), className)}
      {...props}
    />
  )
}

export { Badge, badgeVariants }
